module.exports = __webpack_public_path__ + "static/media/ebook-1.4c62ea92.png";